// extracted by mini-css-extract-plugin
export default {"pageLayout":"d-z","mainContent":"e-z","columnLayout":"f-z","columnLayoutFill":"g-z","columnLayoutLast":"h-z"};